import { Box, Avatar, Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { ReactComponent as LogoSvg } from "../../assets/images/svg/logo/hbscanLogo.svg";
import { useTranslation } from 'react-i18next';
import Topbar from '../../components/topbar/Topbar';

const ErrorScreen = () => {
    const { t } = useTranslation(["common"]);

    return (
        <>
            <Topbar />

            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '100vh',
                    padding: 4,
                    textAlign: 'center',
                }}
            >
                <Avatar
                    alt="hbscanLogo"
                    variant="square"
                    sx={{
                        background: "none",
                        width: 180,
                        height: 60,
                        marginBottom: 4,
                    }}
                >
                    <LogoSvg />
                </Avatar>

                <Box
                    sx={{
                        backgroundColor: '#ffffff',
                        borderRadius: 8,
                        padding: 6,
                        width: '100%',
                        maxWidth: 500,
                        boxShadow: '0px 12px 32px rgba(0, 0, 0, 0.2)',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    <Avatar
                        sx={{
                            backgroundColor: '#fdecea',
                            width: 140,
                            height: 140,
                            marginBottom: 3,
                        }}
                    >
                        <ErrorOutlineIcon sx={{ color: '#f44336', fontSize: 100 }} />
                    </Avatar>

                    <Typography variant="h5" sx={{ fontWeight: 700, marginBottom: 2 }}>
                        {t("servicePlus.titleError")}
                    </Typography>
                    <Typography variant="body1" sx={{ color: '#6c757d' }}>
                        {t("servicePlus.messageError")}
                    </Typography>
                </Box>
            </Box>
        </>
    );
};

export default ErrorScreen;
